import { useTranslation } from "react-i18next";

import { Button } from "../../../components/ui";

export interface RefreshSectionButtonProps {
  onRefresh: () => void;
  loading?: boolean;
}

export default function RefreshSectionButton({
  onRefresh,
  loading = false,
}: RefreshSectionButtonProps) {
  const { t } = useTranslation("common");

  return (
    <Button
      variant="secondary"
      size="sm"
      iconOnly
      loading={loading}
      onClick={onRefresh}
      title={t("monitoreoIa.refresh")}
      aria-label={t("monitoreoIa.refresh")}
      icon={<i className="ri-refresh-line" />}
    />
  );
}
